import React from 'react';

import PropTypes from 'prop-types';

import { Toggle } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import Events from './events/DirectOrNearbyFilterEvents';

import styles from './DirectOrNearbyFilter.scss';

function DirectOrNearbyFilter(props) {
    const {
        allowNearby,
        directOnly,
        onToggleAllowNearby,
        onToggleDirectOnly,
        t,
        totalTrips,
    } = props;

    function handleToggleDirectOnly(isActive) {
        onToggleDirectOnly(isActive);
        Events.directTripsOnlyClicked({ selected: isActive, totalTrips });
    }

    function handleToggleAllowNearby(isActive) {
        onToggleAllowNearby(isActive);
        Events.includeNearbyLocationsClicked({ selected: isActive, totalTrips });
    }

    return (
        <div className={styles.checkboxContainer}>
            <div className={styles.checkboxRow}>
                <Toggle
                    className={styles.checkbox}
                    id="directOnly"
                    labelText={t('no-transfers', {
                        num: directOnly.num,
                    })}
                    on={directOnly.isActive}
                    onChange={handleToggleDirectOnly}
                    delayChange
                />
            </div>
            <div className={styles.checkboxRow}>
                <Toggle
                    className={styles.checkbox}
                    id="allowNearby"
                    labelText={t('nearby-locations_num', {
                        num: allowNearby.num,
                    })}
                    on={allowNearby.isActive}
                    onChange={handleToggleAllowNearby}
                    delayChange
                />
            </div>
        </div>
    );
}

DirectOrNearbyFilter.propTypes = {
    allowNearby: PropTypes.shape({
        isActive: PropTypes.bool,
        num: PropTypes.number,
    }).isRequired,
    directOnly: PropTypes.shape({
        isActive: PropTypes.bool,
        num: PropTypes.number,
    }).isRequired,
    onToggleAllowNearby: PropTypes.func.isRequired,
    onToggleDirectOnly: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    totalTrips: PropTypes.number.isRequired,
};

export { DirectOrNearbyFilter };
export default localize(DirectOrNearbyFilter, 'baseApp');
